
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiElectricalClockOn as ObiElectricalClockOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-electrical-clock-on.js';
 
 
 

 
 export const ObiElectricalClockOn = createComponent({
   react: React,
   tagName: 'obi-electrical-clock-on',
   elementClass: ObiElectricalClockOnElement,
   events: {
     
   }
  });
 
 